import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/service/token-storage.service';

@Component({
  selector: 'app-extra-info',
  templateUrl: './extra-info.component.html',
  styleUrls: ['./extra-info.component.scss']
})
export class ExtraInfoComponent {

  constructor(
    public tokenStorage:TokenStorageService,
    private router: Router,
  ) { }

  logout(){
    this.tokenStorage.signOut();
    this.router.navigate(['/login']);
  }
}
